import { request, METHOD } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/* 获取原产地信息数据列表（#185） */
export function getSoureareaList() {
  return request("".concat(BASE_URL) + "/countryOfOrign/list", METHOD.GET);
}

/* 更新原产地状态信息数据（#189） */
export function updateSourceAreaStatus(data) {
  return request("".concat(BASE_URL) + "/countryOfOrign/status", METHOD.PUT, data);
}
/* 删除原产地信息数据（#190） */
export function deleteSourceArea(id) {
  return request("".concat(BASE_URL) + "/countryOfOrign/" + id, METHOD.DELETE);
}

/*新增原产地信息数据（#186） */
export function addSourceArea(data) {
  return request("".concat(BASE_URL) + "/countryOfOrign", METHOD.POST, data);
}

/* 获取原产地信息数据（#187） */
export function getSourceAreaDetail(id) {
  return request("".concat(BASE_URL) + "/countryOfOrign/" + id, METHOD.GET);
}

/* 更新原产地信息数据（#188）） */
export function updateSourceAreaInfo(data) {
  return request("".concat(BASE_URL) + "/countryOfOrign", METHOD.PUT, data);
}
export default {
  getSoureareaList: getSoureareaList,
  updateSourceAreaStatus: updateSourceAreaStatus,
  deleteSourceArea: deleteSourceArea,
  addSourceArea: addSourceArea,
  getSourceAreaDetail: getSourceAreaDetail,
  updateSourceAreaInfo: updateSourceAreaInfo
};